import HeaderLogos from './HeaderLogos';

export default HeaderLogos;